export enum EbpCaseProgressColor {
  Green = 'green',
  Amber = 'amber',
  Red = 'red',
  Grey = 'grey',
}
